import React from 'react';
import NoSSR from 'react-no-ssr';
import MediaQuery from 'react-responsive';

import { trans, getResourcePath } from '@spotahome/soyuz/client';
import { Section } from '@spotahome/ui-library';

import Hero from '../../common/components/Hero';
import HeaderContainer from '../../common/components/HeaderContainer';
import Footer from '../../common/components/Footer';
import Cookies from '../../common/components/Cookies';

import SessionExpiredModal from '../../common/components/SessionExpiredModal';

import AppBanner from '../../common/components/AppBanner';

import {
  MQ_TABLET_MIN_WIDTH,
  MQ_MOBILE_MAX_WIDTH
} from '../../common/constants';

import AboutDifferent from './components/AboutDifferent';
import AboutStart from './components/AboutStart';
import AboutMission from './components/AboutMission';
import AboutBuild from './components/AboutBuild';

import AboutPress from './components/AboutPress';

// Styles
import './../../common/scss/init.scss';

const AboutUsContainer = () => (
  <div>
    <NoSSR>
      <MediaQuery minWidth={MQ_TABLET_MIN_WIDTH}>
        <Hero
          menu={<HeaderContainer tracking="ga-about-us" />}
          title={trans('about-us.hero.title')}
          backgroundImage={`url(${getResourcePath(
            '/images/about-us/background-header.jpg'
          )})`}
        />
      </MediaQuery>
    </NoSSR>

    <NoSSR>
      <MediaQuery maxWidth={MQ_MOBILE_MAX_WIDTH}>
        <Hero
          menu={<HeaderContainer tracking="ga-about-us" />}
          title={trans('about-us.hero.title')}
          backgroundImage={`url(${getResourcePath(
            '/images/about-us/mobile-header.jpg'
          )})`}
        />
      </MediaQuery>
    </NoSSR>

    <Section background="light">
      <AboutDifferent />
    </Section>

    <Section background="light">
      <AboutStart />
    </Section>

    <Section background="skin">
      <AboutMission />
    </Section>

    <AboutBuild />

    <Section background="light">
      <AboutPress />
    </Section>

    <Footer />
    <SessionExpiredModal />
    <Cookies />
    <AppBanner />
  </div>
);

export default AboutUsContainer;
